<template>
  <v-card hover :to="link" height="100%" class="debt-card">
    <v-card-title>
      <v-row no-gutters>
        <v-col cols="12" class="text-center">
          <h5 class="mt-0 mb-3 text-h5" v-if="paymentPlan.isJointPaymentPlan">
            {{ $t('paymentPlan') }}
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="grey"
                        dark
                        v-bind="attrs"
                        v-on="on">fas fa-info-circle</v-icon>
              </template>
              <span>{{ $t('thisIsMultidebt') }}</span>
            </v-tooltip>
          </h5>
          <h5 class="mt-0 mb-3 text-h5" v-else>
            {{ paymentPlan.debts[0].creditor.name }}
          </h5>
          <p class="mb-0" v-if="paymentPlan.nextInstallment.duedate !== null">{{ $t('dueDate') }}: {{ paymentPlan.nextInstallment.duedate | formatDate }}</p>
        </v-col>
      </v-row>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-row no-gutters >
        <v-col cols="12" class="text-center">
          <debt-wheel :value="paymentPlan.summary.progress"
                      :size="150"
                      :width="10"
                      :rotate="-90"
                      :segments="paymentPlan.installments.length"
                      color="color-new-link-blue">
            <div class="d-flex flex-column">
              <div class="grey--text">{{ $t('left') }}</div>
              <div class="text-subtitle-1 color-new-link-blue--text"><b>{{ paymentPlan.summary.left | currency }}</b></div>
              <div class="grey--text" v-if="paymentPlan.paymentPlan !== null">
                {{ paymentPlan.installments.length - (paymentPlan.nextInstallment.sequence - 1) }} / {{ paymentPlan.installments.length }} {{ $t('installments') }}
              </div>
            </div>
          </debt-wheel>
          <p class="my-2">
            {{ $t('paid') }}
            {{ paymentPlan.summary.totalPaid | currency }} /
            {{ paymentPlan.summary.total | currency }}
          </p>
          <v-btn tile color="color-orange" dark v-if="isDueDateInPast(paymentPlan.nextInstallment)" class="px-4">{{ $t('payQuicklyPaymentPlan') }}</v-btn>
          <v-btn tile color="primary" v-else class="px-4">{{ $t('payNextInstallment') }}</v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  import moment from 'moment'

  export default {
    props: ['paymentPlan'],
    computed: {
      link () {
        return this.paymentPlan.isJointPaymentPlan ? '/payment-plan/' + this.paymentPlan.debts[0].nr : '/debt/' + this.paymentPlan.debts[0].nr
      }
    },
    methods: {
      isDueDateInPast (installment) {
        if (installment.duedate === null) {
          return false
        } else if (moment(installment.duedate) <= moment().add(2, 'days')) {
          return true
        } else {
          return false
        }
      }
    }
  }
</script>
